module.exports = "<div class=\"font-weight-bold\" style=\"font-size: 2.125rem\">Detect<span class=\"font-weight-light\">SUN Tool</span></div>\n"